import React from 'react';
import Icon from '../shared/Icon';
import { formatWaiting } from '../../../utils/reviewWaiting';

/**
 * The parked-document queue, oldest-upload-first.
 *
 * A document with no flags reads "unreadable" rather than "0 fields", which
 * would look done. `pending_since` marks the stale end of a backlog.
 */
const DocumentReviewQueue = ({
  documents,
  activeIndex,
  nextCursor,
  loadingMore,
  onSelect,
  onLoadMore,
}) => (
  <ul className="docreview-doclist">
    {documents.map((d, i) => {
      const count = (d.flags || []).length;
      const waiting = formatWaiting(d.pending_since);
      return (
        <li key={d.document_id}>
          <button
            type="button"
            className={`resui-card resui-card--elevated docreview-docitem${i === activeIndex ? ' is-selected' : ''}`}
            aria-current={i === activeIndex ? 'true' : undefined}
            onClick={() => onSelect(i)}
          >
            {/* Figma 1018-2835 Bridge card: file name on the first row, its meta
                spread across a second row — field count left, waiting right —
                rather than stacked in a right-hand column. The rail is narrow, so
                stacking squeezed the name. */}
            <span className="docreview-docitem-head">
              <Icon name="description" className="docreview-docitem-icon" size={18} />
              <span className="docreview-docitem-name">{d.file_name || d.document_id}</span>
            </span>
            <span className="docreview-docitem-meta">
              <span>{count === 0 ? 'unreadable' : `${count} field${count === 1 ? '' : 's'}`}</span>
              {waiting && <span className="docreview-docitem-waiting">{waiting}</span>}
            </span>
          </button>
        </li>
      );
    })}
    {/* Cursor-paginated: a non-null next_cursor means more parked documents
        exist than this page carries. */}
    {nextCursor && (
      <li>
        {/* Small tertiary, labelled "Load more" — design's call, along with
            loading in 200-document increments the reviewer asks for rather than
            filling the rail automatically. The canonical button, not a bespoke
            dashed affordance; `.docreview-loadmore` now only stretches it to the
            rail's width. */}
        <button
          type="button"
          className="resui-btn resui-btn--small resui-btn--tertiary docreview-loadmore"
          disabled={loadingMore}
          onClick={onLoadMore}
        >
          {loadingMore ? 'Loading…' : 'Load more'}
        </button>
      </li>
    )}
  </ul>
);

export default DocumentReviewQueue;
